// libraries
import { Tab, Tabs } from "@mui/material"

// providers
import { trans } from "@/_providers/Translation"
import moment from "moment"

export default function WeekTabs({ handleSearch, data }) {
  function handleWeek(name) {
    const currentWeekIdentifier = reverseCalcWeekStart(data.start)

    if (name === "previous" && currentWeekIdentifier === "previous") return
    if (name === "next" && currentWeekIdentifier === "next") return

    let date = calcWeekStart(name)
    handleSearch("start", date)
    handleSearch("end", moment(date).add(6, "days").format("YYYY-MM-DD"))
  }

  function calcWeekStart(name) {
    let interval

    let date = new Date()

    switch (name) {
      case "previous":
        interval = date.getTime() - 60 * 60 * 24 * 7 * 1000
        break
      case "this":
        interval = date.getTime()
        break
      case "next":
        interval = date.getTime() + 60 * 60 * 24 * 7 * 1000
        break
    }

    let beforeOneWeek = new Date(interval)
    let day = beforeOneWeek.getDay()
    let diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1)
    let lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))

    let _year = lastMonday.getFullYear()
    let _month = (lastMonday.getMonth() + 1).toString().padStart(2, 0)
    let _day = lastMonday.getDate().toString().padStart(2, 0)

    let fulldate = [_year, _month, _day].join("-")

    return fulldate
  }

  function reverseCalcWeekStart(dateStr) {
    if (!dateStr) return "this"

    const inputDate = new Date(dateStr)
    const today = new Date()

    const inputDay = inputDate.getDay()
    const inputMonday = new Date(inputDate)
    inputMonday.setDate(
      inputDate.getDate() - inputDay + (inputDay === 0 ? -6 : 1),
    )
    inputMonday.setHours(0, 0, 0, 0)

    const todayDay = today.getDay()
    const currentMonday = new Date(today)
    currentMonday.setDate(
      today.getDate() - todayDay + (todayDay === 0 ? -6 : 1),
    )
    currentMonday.setHours(0, 0, 0, 0)

    const diffTime = inputMonday.getTime() - currentMonday.getTime()
    const diffWeeks = diffTime / (7 * 24 * 60 * 60 * 1000)

    if (diffWeeks < -0.5) return "previous"
    else if (diffWeeks > 0.5) return "next"
    else return "this"
  }

  return (
    <Tabs
      value={reverseCalcWeekStart(data.start)}
      onChange={(e, newValue) => handleWeek(newValue)}
      variant="scrollable"
      scrollButtons="auto"
      indicatorColor="primary"
      textColor="primary"
      aria-label="scrollable force tabs example"
      allowScrollButtonsMobile
    >
      <Tab value="previous" label={trans("random.lastWeek")} />
      <Tab value="this" label={trans("random.currentWeek")} />
      <Tab value="next" label={trans("random.nextWeek")} />
    </Tabs>
  )
}
